import React, { useContext } from 'react';


import { LanguageContext } from '../context/LanguageContext';
import commonTranslations from '../languages/common.json';

export const Administration = () => {
  const { lang } = useContext(LanguageContext);
  const t = commonTranslations[lang].common;
  return (
    <div className="administration">
      <h3>{t.administration}</h3>
    </div>
  );
};
